// extracted by mini-css-extract-plugin
export default {"root":"athlete-card-price-line_root__Frywa"};